import React, { useContext, useEffect, useState } from 'react';
import styles from './AdminMobileModal.module.css';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import useCustomAdminMobileMove from 'routes/adminMobile/hooks/useCustomAdminMobileMove';
import cancelIcon from 'routes/vendorRe/images/cancel_icon.png';
import P from 'components/P';
import { AuthContext } from 'providers/AuthProvider';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import { requester } from 'App';

// 스타일 변수
const fontSize1 = 'max(1.5vw, 25px)';
const fontSize2 = 'max(0.8vw, 12px)';
const fontColor1 = 'white';
const gap1 = '0.5rem';
const padd1 = '1.5rem';

const AdminMobileModal = ({ callbackFn }) => {
    const { userName, roles } = useContext(AuthContext);
    const [isMounted, setMounted] = useState(false);
    const [totalPrice, setTotalPrice] = useState();
    const {
        moveToStoreCategory, 
        moveToUserManagement, 
        moveToMachManagement,
        moveToStats,
        moveToOrder
    } = useCustomAdminMobileMove();

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            requester.getVendorSettlementFee(result => {
                setTotalPrice(result.data.totalPrice);
                
            });
        }
    }, [isMounted]);

    return (
        <div className={styles.layer}>
            <div className={styles.popup}>
                <Container>
                    <VerticalFlex>
                        <FlexChild
                            backgroundColor="#FE531F"
                            padding={padd1}
                            justifyContent="space-around"
                            height="auto"
                        >
                            <VerticalFlex gap={gap1}>
                                <FlexChild alignItems="flex-end">
                                    <img
                                        onClick={() => {
                                            if (callbackFn) {
                                                callbackFn();
                                            }
                                        }}
                                        className={styles.cancel}
                                        src={cancelIcon}
                                        alt="취소 아이콘"
                                    />
                                </FlexChild>
                                <FlexChild alignItems="flex-start">
                                    <P size={fontSize1} color={fontColor1}>
                                        {userName ? userName : 'NONE'}
                                    </P>
                                </FlexChild>
                                <FlexChild alignItems="flex-start">
                                    <P size={fontSize2} color={fontColor1}>
                                        {roles ? roles : 'NONE'}
                                    </P>
                                </FlexChild>
                                <FlexChild alignItems="flex-start">
                                    <HorizontalFlex gap={gap1}>
                                        <FlexChild width="auto">
                                            <span
                                                style={{
                                                    fontSize: fontSize1,
                                                    color: fontColor1,
                                                }}
                                            >
                                                이달의 매출
                                            </span>
                                        </FlexChild>
                                        <FlexChild>
                                            <span
                                                style={{
                                                    fontSize: fontSize1,
                                                    color: fontColor1,
                                                }}
                                            >
                                                {totalPrice
                                                    ? totalPrice.toLocaleString()
                                                    : 0}
                                                원
                                            </span>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild height="auto">
                            <VerticalFlex padding={padd1}>
                                <FlexChild>
                                    <div
                                        className={styles.menuDiv}
                                        onClick={() => {
                                            moveToStoreCategory();
                                            if (callbackFn) {
                                                callbackFn();
                                            }
                                        }}
                                    >
                                        카테고리 관리
                                    </div>
                                    <div
                                        className={styles.menuDiv}
                                        onClick={() => {
                                            moveToUserManagement();
                                            if (callbackFn) {
                                                callbackFn();
                                            }
                                        }}
                                    >
                                        유저 관리
                                    </div>
                                    <div
                                        className={styles.menuDiv}
                                        onClick={() => {
                                            moveToMachManagement();
                                            if (callbackFn) {
                                                callbackFn();
                                            }
                                        }}
                                    >
                                        자판기 관리
                                    </div>
                                    <div
                                        className={styles.menuDiv}
                                        onClick={() => {
                                            moveToStats();
                                            if (callbackFn) {
                                                callbackFn();
                                            }
                                        }}
                                    >
                                        통계
                                    </div>
                                    <div
                                        className={styles.menuDiv}
                                        onClick={() => {
                                            moveToOrder();
                                            if (callbackFn) {
                                                callbackFn();
                                            }
                                        }}
                                    >
                                        발주 관리
                                    </div>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </Container>
            </div>
        </div>
    );
};

export default AdminMobileModal;
